export default "__VITE_ASSET__BZNjzRzi__"